import { availableCountries } from '../../../utils';

export enum SUPPLEMENTARY_FIELDS {
  'bday' = 'bday',
  'countryName' = 'country-name',
  'gender' = 'gender',
  'username' = 'username',
  'givenName' = 'given-name',
  'familyName' = 'family-name',
  'promoEmailAgreement' = 'promo_email_agreement',
  'additionalAgreement' = 'additional_agreement'
}

export const defaultTypes: Record<SUPPLEMENTARY_FIELDS, string> = {
  bday: 'date',
  'country-name': 'select',
  gender: 'select',
  username: 'str',
  'given-name': 'str',
  'family-name': 'str',
  promo_email_agreement: 'bool',
  additional_agreement: 'bool'
} as const;

export const GenderOptions = ['m', 'f'];

export const defaultSelectableValues: Record<string, string[]> = {
  gender: GenderOptions,
  'country-name': availableCountries
};
